export enum LayoutName {
    BLANK = "BlankLayout",
    DASHBOARD = "DashboardLayout",
    DASHBOARD_AUTH = "DashboardAuthLayout"
}

export type HexColor = `#${string}`;
